import { useTranslation } from "react-i18next";
import styled from "styled-components"
import { useNavigate } from "react-router-dom"
import { Button } from "../../../../ui/button"
import { Checkbox } from "../../../../ui/checkbox"
import { useZ3950 } from "../../../controllers/Z3950Controller"
import { Form, Input, Typography, Row, Col, ExpandableText, Select } from "../../../../ui/ot"
import { useProTableOt } from '../../../../utility/componentOt/controllers/ProtableOtController'
import ProTableOt from '../../../../utility/componentOt/views/ProtableOt'
import { useEffect, useRef } from "react"
import CardView from './../../../components/CardView'
import { useState } from "react";

const SearchZ3950 = ({
    permission_level = null, 
}) => {
    const { t } = useTranslation('translation')
    const i18nPrefix = "library.searchZ3950."
    const actionRef = useRef()
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const Columns = [
        {
            title: t(`${i18nPrefix}Title`),
            dataIndex: 'title',
            key: 'title',
            width: 350,
            render: (text, record, index) => {
                return (<ExpandableText maxLines={1} text={text} />)
            }
        },
        {
            title: t(`${i18nPrefix}Author`),
            dataIndex: 'author',
            key: 'author',
        },
        {
            title: t(`${i18nPrefix}Year`),
            dataIndex: 'year',
            key: 'year',
        },
        {
            title: t(`${i18nPrefix}Edition`),
            dataIndex: 'edition',
            key: 'edition',
        },
        {
            title: 'ISBN',
            dataIndex: 'isbn',
            key: 'isbn',
        },
        {
            title: 'ISSN',
            dataIndex: 'issn',
            key: 'issn',
        },
        {
            title: 'LCCN',
            dataIndex: 'LCCN',
            key: 'LCCN',
        },
        {
            title: t(`${i18nPrefix}Actions`),
            dataIndex: 'Actions',
            key: 'Actions',
            render: (text, record, index) => {
                return (
                    <CardView
                        card={<>
                            <Typography.P>{record?.author}</Typography.P>
                            <Typography.P><span style={{ fontWeight: 'bold' }}>{record?.title}</span>{record?.edition}&nbsp;{record?.publisher}</Typography.P>
                        </>}
                        marc={record?.marcstring}
                        record={record}
                        permission_level={permission_level}
                    >
                    </CardView>
                )
            }
        },
    ]
    const [selectOptions, setSelectOptions] = useState([])
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        Columns
    })

    const {
        getZ3950Providers,
        getZ3950Data
    } = useZ3950({
        onBefore: () => { },
        onFinish: () => { }
    })
    useEffect(() => {
        document.title = "Z39.50搜尋"
        getZ3950Providers()
            .then((providers) => {
                setSelectOptions(providers)
                form.setFieldsValue({
                    server_name: providers.map((provider) => provider.id),
                })
            })
            .catch(() => setSelectOptions([]))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <Row>
            <Col
                span={24}
            >
                <Form form={form}>
                    <Row>
                        <Col xxl={6} xl={6} lg={8} md={12} sm={12} xs={24}>
                            <Form.Item
                                labelCol={24}
                                wrapperCol={24}
                                name="isbn"
                                label="ISBN"
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xxl={6} xl={6} lg={8} md={12} sm={12} xs={24}>
                            <Form.Item
                                labelCol={24}
                                wrapperCol={24}
                                name="issn"
                                label="ISSN"
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xxl={6} xl={6} lg={8} md={12} sm={12} xs={24}>
                            <Form.Item
                                labelCol={24}
                                wrapperCol={24}
                                name="title"
                                label={t(`${i18nPrefix}Title`)}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xxl={6} xl={6} lg={8} md={12} sm={12} xs={24}>
                            <Form.Item
                                labelCol={24}
                                wrapperCol={24}
                                name="author"
                                label={t(`${i18nPrefix}Author`)}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xxl={6} xl={6} lg={8} md={12} sm={12} xs={24}>
                            <Form.Item
                                labelCol={24}
                                wrapperCol={24}
                                name="keyword"
                                label={t(`${i18nPrefix}Keyword`)}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xxl={6} xl={6} lg={8} md={12} sm={12} xs={24}>
                            <Form.Item
                                labelCol={24}
                                wrapperCol={24}
                                name="server_name"
                                label={"搜尋來源"}
                            >
                                <Select
                                    onlyValue={true}
                                    mode={"multiple"}
                                    allowClear
                                    options={selectOptions.map((item, index) => ({
                                        label: item.name || `來源${index + 1}`,
                                        value: item.id,
                                    }))}
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={12} xl={12} lg={8} md={12} sm={12} xs={24}>
                            <Row justify={"end"}>
                                <Col>

                                    <Button
                                        onClick={() => {
                                            actionRef.current.reloadAndRest()
                                        }}>{t("search")}</Button>
                                    <Button variant="ghost" onClick={() => navigate('/library/backstage/ManageMARCRecord')}>{t("cancel")}</Button>
                                </Col>
                            </Row>
                        </Col>
                        {/* <Col span={24}>
                            <Row justify={"space-between"}>
                                <Col xxl={6} xl={6} lg={8} md={12} sm={12} xs={24}>
                                    <Form.Item
                                        name="keyword"
                                        label={t(`${i18nPrefix}Keyword`)}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <ButtonGroup>
                                        <Button onClick={() => { actionRef.current.reloadAndRest() }}>{t("search")}</Button>
                                        <Button variant="ghost" onClick={() => navigate('/library/backstage/ManageMARCRecord')}>{t("cancel")}</Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </Col> */}


                    </Row>
                </Form>

            </Col>
            <Col
                span={24}
            >
                <ProTableOt
                    showSearch={false}
                    actionRef={actionRef}
                    columns={Columns}
                    searchParams={{
                        selectOptions
                    }}
                    request={async (params = {}, sort, filter) => {
                        // setAxiosMode("get")
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            marcdata: "json",
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                        };
                        let search = []
                        let providerIds = []
                        Object.entries(form.getValues()).forEach(([key, value]) => {
                            if (key !== "server_name" && typeof value === "string" && value.trim() !== "") {
                                search.push({ field: key, keyword: value })
                            }
                            if (key === "server_name") {
                                providerIds = Array.isArray(value) ? value : []
                            }

                        })

                        newParams = {
                            ...newParams,
                            provider_ids: providerIds,
                            search: search
                        }
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        // setPageSize(params?.pageSize ?? 20)

                        return getZ3950Data({
                            ...newParams
                        })
                    }}
                    rowSelection={false}
                    scroll={{ x: 'max-content' }}
                />
            </Col>
        </Row>

    )
}

const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.2em;
font-weight: 600;
}
`

const Em20 = styled.div`
width: 20em;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

const FlexBox = styled.div`
display: flex;
flex-direction: row;
flex-wrap: nowrap;
align-items: flex-start;
justify-content: flex-start;
gap: 1em;
`

const VerticalFlexBox = styled.div`
display: flex;
flex-direction: column;
flex-wrap: nowrap;
align-items: flex-start;
justify-content: flex-start;
gap: 1em;
`

const ContextBox = styled.div`
display: flex;
flex-direction: row;
flex-wrap: wrap;
align-items: center;
justify-content: center;
gap: 1em;
`

const WhiteBox = styled.div`
background-color: #fff;
padding: 1em;
`

export default SearchZ3950
